import React from 'react';
import { useLocation } from 'react-router-dom';

const ErrorPage: React.FC = () => {
  const location = useLocation();
  const error = location.state?.error || 'An error occurred';

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <h1>{error}</h1>
    </div>
  );
};

export default ErrorPage;